// src/components/admin/EditCategoryModal.jsx
import React, { useState, useEffect } from "react";
import { BsX } from "react-icons/bs";
import { useCategoryStore } from "../../store/serviceStore";
import { toast } from "react-toastify";

const EditCategoryModal = ({
  isEditCategoryModalOpen,
  closeEditCategoryModal,
  selectedCategory,
}) => {
  const { updateCategory, categoryUpdateLoading } = useCategoryStore();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  // Initialiser le formulaire avec les données de la catégorie
  useEffect(() => {
    if (selectedCategory) {
      setFormData({
        name: selectedCategory.name || "",
        description: selectedCategory.description || "",
      });
    }
  }, [selectedCategory]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log({ selectedCategory });
    if (!selectedCategory) {
      toast.error("Aucune catégorie sélectionnée");
      return;
    }

    // Validation
    if (!formData.name.trim()) {
      toast.error("Le nom de la catégorie est requis");
      return;
    }

    try {
      console.log("selectedCategory.id", selectedCategory.id, { formData });
      await updateCategory(selectedCategory.id, formData);
      handleClose();
    } catch (error) {
      // L'erreur est déjà gérée dans le store
    }
  };

  const handleClose = () => {
    setFormData({
      name: "",
      description: "",
    });
    closeEditCategoryModal();
  };

  // Vérifier si des modifications ont été apportées
  const hasChanges = () => {
    if (!selectedCategory) return false;
    return (
      formData.name !== selectedCategory.name ||
      formData.description !== selectedCategory.description
    );
  };

  if (!isEditCategoryModalOpen || !selectedCategory) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-md">
        {/* En-tête */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div>
            <h2 className="font-poppins font-semibold text-[18px] text-title">
              Modifier la catégorie
            </h2>
            <p className="font-nunito text-[14px] text-text mt-1">
              ID: {selectedCategory.id}
            </p>
          </div>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 transition-colors"
            disabled={categoryUpdateLoading}
          >
            <BsX size={24} />
          </button>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Nom de la catégorie */}
          <div>
            <label className="block font-poppins font-medium text-[15px] text-subtitle mb-2">
              Nom de la catégorie *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              disabled={categoryUpdateLoading}
              className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-secondary-500 disabled:bg-gray-50 disabled:cursor-not-allowed font-nunito text-[14px] text-text"
              placeholder="Entrez le nom de la catégorie"
            />
          </div>

          {/* Description */}
          <div>
            <label className="block font-poppins font-medium text-[15px] text-subtitle mb-2">
              Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={3}
              disabled={categoryUpdateLoading}
              className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-secondary-500 disabled:bg-gray-50 disabled:cursor-not-allowed font-nunito text-[14px] text-text"
              placeholder="Description de la catégorie"
            />
          </div>

          {/* Statut actuel */}
          <div>
            <label className="block font-poppins font-medium text-[15px] text-subtitle mb-2">
              Statut actuel
            </label>
            <div
              className={`inline-flex items-center px-3 py-1 font-nunito text-[14px] text-text font-medium ${
                selectedCategory.isActive
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {selectedCategory.isActive ? "🟢 Actif" : "🔴 Inactif"}
            </div>
          </div>

          {/* Boutons */}
          <div className="flex justify-between items-center pt-4 border-t border-gray-200">
            <div className="font-nunito text-[14px] text-text text-sm">
              {hasChanges() && "⚠️ Des modifications non sauvegardées"}
            </div>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={handleClose}
                disabled={categoryUpdateLoading}
                className="px-4 py-2 text-gray-600 border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-nunito font-semibold text-[14px]"
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={categoryUpdateLoading || !hasChanges()}
                className="px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 font-nunito font-semibold text-[14px]"
              >
                {categoryUpdateLoading && (
                  <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
                )}
                {categoryUpdateLoading ? "Modification..." : "Modifier"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCategoryModal;